module.exports = ".ipt-icon-right {\n  cursor: pointer;\n  margin-left: 0.5em;\n  vertical-align: middle; }\n  .ipt-icon-right:hover {\n    color: #666; }\n"